import { createSlice } from "@reduxjs/toolkit"

const initialState= { 
    callId: null,
    clientCode: null
}

const appStateSlice = createSlice({
    name: 'appState',
    initialState,
    reducers: {
      setEntryParams(state, action) {
        state.callId = action.payload.callId;
        state.clientCode = action.payload.clientCode
      },
    },
  })
  
  export const { setEntryParams } = appStateSlice.actions
  export default appStateSlice.reducer